import { appsConfig } from 'config/apps-data';
import { values } from 'lodash/fp';

export default function useApps() {
  const urlItems = location.pathname.split('/').filter(o => o);
  const urlKey = urlItems[0] ?? '';
  const currentApp = appsConfig[urlKey];

  return {
    currentApp,
    appKey: currentApp ? urlKey : null,
    urlKey,
    // Apps listed on the home page and in the app switcher.
    appItems: values(appsConfig).filter(app => !app.hidden),
  };
}
